import { useState, useEffect } from 'react';
import { buildApiUrl } from '../config/environment';

// ============================================================================
// SUBSCRIPTION AND PRICING STATE HOOK - EXTRACTED FROM App.tsx
// ============================================================================

interface SubscriptionTier {
  id: string;
  name: string;
  displayName: string;
  icon: string;
  color: string;
  price: number;
  currency: string;
  billingCycle: string;
  description: string;
  features: {
    maxRestaurants: number;
    maxSearchRadius: number;
    basicInfo: boolean;
    photos: boolean;
    walkingDirections: boolean;
    preferences: boolean;
    multipleNetworks: boolean;
    advancedSearch: boolean;
    routePlanning: boolean;
    offlineCache: boolean;
    prioritySupport: boolean;
  };
  limits: {
    restaurantsPerSearch: number;
    searchRadiusKm: number;
    apiCallsPerHour: number;
    searchesPerDay: number;
  };
}

interface UserSubscription {
  tier: string;
  status: string;
  expiresAt: string | null;
  isActive: boolean;
  isTrial: boolean;
}

export const useSubscriptionState = () => {
  const [pricingPlans, setPricingPlans] = useState<any[]>([]);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);
  const [userLocation, setUserLocation] = useState<{latitude: number, longitude: number} | null>(null);
  const [userSubscription, setUserSubscription] = useState<UserSubscription | null>(null);
  const [availableTiers, setAvailableTiers] = useState<SubscriptionTier[]>([]);

  // Fetch user subscription status
  const fetchUserSubscription = async () => {
    try {
      setIsLoadingSubscription(true);
      const response = await fetch(buildApiUrl('/api/subscription/status'), {
        credentials: 'include'  // Use cookie-based authentication instead of JWT
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserSubscription(data);
      }
    } catch (error) {
      console.error('Failed to fetch subscription status:', error);
    } finally {
      setIsLoadingSubscription(false);
    }
  };

  // Fetch available subscription tiers
  const fetchAvailableTiers = async () => {
    try {
      console.log('🎯 fetchAvailableTiers() called');
      const response = await fetch(buildApiUrl('/api/subscription/tiers'));
      console.log('🎯 fetchAvailableTiers response status:', response.status);
      if (response.ok) {
        const data = await response.json();
        console.log('🎯 fetchAvailableTiers data:', data);
        setAvailableTiers(data.tiers || []);
        console.log('🎯 setAvailableTiers called with:', data.tiers?.length, 'tiers');
      } else {
        console.error('🎯 fetchAvailableTiers response not ok:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('🎯 fetchAvailableTiers error:', error);
    }
  };

  return {
    // Subscription state
    pricingPlans,
    isLoadingSubscription,
    userLocation,
    userSubscription,
    availableTiers,
    
    // Setters
    setPricingPlans,
    setIsLoadingSubscription,
    setUserLocation,
    setUserSubscription,
    setAvailableTiers,
    
    // Actions
    fetchUserSubscription,
    fetchAvailableTiers,
  };
};
